// removed by extract-text-webpack-plugin
module.exports = {"EditorGUI":"EditorGUI___2c9ZA","container":"container___1OfoA","topNav":"topNav___2sAZ4","vars":"vars___VGWcU","label":"label___1eVZJ","input":"input___eb6y7","list":"list___1d_Xo","listContent":"listContent___2zqIq","bottomOptions":"bottomOptions___1aOy3","save":"save___249U0","btn":"btn___3pps_","currentTab":"currentTab___2UNIQ","saving":"saving___2gSvE","loading":"loading___2tpKY","warn":"warn___3nZe7","pageToolsStandAlone":"pageToolsStandAlone___2akRW","EditorGUIStandAlone":"EditorGUIStandAlone___36L6j","warning":"warning___CK02Q"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/styles.scss
// module id = 336
// module chunks = 0